<p-table #table [value]="(items$ | async) ?? []" [paginator]="true" [rows]="10" [alwaysShowPaginator]="false"
  [selectionMode]="isIndirizzi ? 'multiple' : 'single'" [(selection)]="selectedIndirizzi">
  <ng-template pTemplate="header">
    <tr>
      <th>{{itemTitle}}</th>
      <th [class]="isIndirizzi ? 'col3buttons' : 'col2buttons'" rowspan="2">
        <button *ngIf="showAddButton" class="addButton mr-1" pButton type="button" icon="fas fa-plus" (click)="openModal('new')"
          title="Aggiungi" [disabled]="!canModified"></button>
        <button *ngIf="itemTitle !== 'Utente' && isIndirizzi" [disabled]="(selectedIndirizzi?.length ?? 0) < 2"
          class="addButton p-button-info mr-1" pButton type="button" title="Raggruppa" icon="fas fa-sync"
          (click)="openSyncIndirizzi()"></button>
      </th>
    </tr>
    <tr>
      <th>
        <input pInputText type="text" placeholder="Filtra..." style="width:100%"
          (input)="table.filter($any($event.target).value || '', nameProperty, 'contains')">
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item">
      <td>{{ item[this.nameProperty] }}</td>
      <td [class]="isIndirizzi ? 'p-d-flex' : ''">
        <button pButton type="button" style="margin-right: 5px;" icon="fas fa-pen" class="p-button-warning"
          title="Modifica" (click)="openModal('edit', item)" [disabled]="!canModified || (isIndirizzi && item.bloccato)"></button>
        <button pButton type="button" icon="fas fa-times" class="p-button-danger" title="Elimina"
          (click)="removeItem(item)" [disabled]="!canModified || (isIndirizzi && item.bloccato)"></button>
        <ng-container *ngIf="isIndirizzi">
          <button pButton type="button" [icon]="item.bloccato ? 'pi pi-lock' : 'pi pi-unlock'" style="margin-left: 5px;"
            [class.p-button-danger]="item.bloccato" [class.p-button-success]="!item.bloccato"
            [title]="item.bloccato ? 'Sblocca' : 'Blocca'" (click)="bloccaIndirizzo(item)" [disabled]="!canModified"></button>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="2">
        Nessun elemento
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="isDialogOpen" [modal]="true" [closable]="false" [closeOnEscape]="false">
  <p-header>
    <span *ngIf="editMode === 'new'">Aggiungi {{itemTitle}}</span>
    <span *ngIf="editMode === 'edit'">Modifica {{itemTitle}}</span>
    <span *ngIf="editMode === 'sync'">Raggruppa {{itemTitle}}</span>
  </p-header>
  <form [formGroup]="form" *ngIf="editMode !== 'sync'">
    <div class="card grid">
      <div class="col-3" style="margin-top:6px;">Nome*</div>
      <div class="col-9">
        <input id="name" type="text" pInputText formControlName="name">
      </div>
    </div>
  </form>

  <div *ngIf="editMode === 'sync'" class="min-content">
    <p-table class="noSize" [value]="selectedIndirizzi" [(selection)]="selectIndirizzo" dataKey="indirizzoId"
      (onRowSelect)="setFormSelect()">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th style="width: 25rem">Nome</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-indirizzo>
        <tr>
          <td><p-tableRadioButton [value]="indirizzo"></p-tableRadioButton></td>
          <td>{{indirizzo.nomeIndirizzo}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div style="text-align: left">
          Raggruppa in: {{selectIndirizzo ? selectIndirizzo.nomeIndirizzo : 'nessun indirizzo selezionato'}}
        </div>
      </ng-template>
    </p-table>
  </div>

  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" (click)="resetForm()"></button>
    <button pButton type="button"
      [label]="editMode === 'new' ? 'Aggiungi' : editMode === 'sync' ? 'Raggruppa' : 'Modifica'" (click)="saveItem()"
      [disabled]="form.invalid || (!selectIndirizzo && editMode === 'sync')"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showHideDialog" [modal]="true" [closable]="false" [closeOnEscape]="false" [style]="{ width: '30%' }">
  <p-header>
    <span class="font-normal">Indirizzo associato a documenti</span>
  </p-header>
  <div class="p-3">
    <p>L'indirizzo <b>{{indirizzoToHide ? indirizzoToHide[nameProperty] : ''}}</b> è associato a uno o più documenti e non può essere eliminato.</p>
    <p>Vuoi nascondere questo indirizzo? Verrà portato in stato Bloccato e non sarà più visibile nelle selezioni per nuovi documenti.</p>
  </div>
  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" icon="pi pi-times" title="Annulla"
      (click)="cancelHide()"></button>
    <button pButton type="button" label="Blocca" class="p-button-warning" icon="pi pi-lock" title="Blocca indirizzo"
      (click)="confirmHideIndirizzo()"></button>
  </p-footer>
</p-dialog>

<p-toast key="toast" position="top-center"></p-toast>
